var SensorML_2_0_Module_Factory = function () {
  var SensorML_2_0 = {
    n: 'SensorML_2_0',
    dens: 'http:\/\/www.opengis.net\/sensorml\/2.0',
    dans: 'http:\/\/www.w3.org\/1999\/xlink',
    deps: ['XLink_1_0', 'GML_3_2_1', 'SWE_2_0', 'ISO19139_GMD_20070417'],
    tis: [{
        ln: 'TemporalFramePropertyType',
        ps: [{
            n: 'temporalFrame',
            rq: true,
            en: 'TemporalFrame',
            ti: '.TemporalFrameType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ObservablePropertyPropertyType',
        ps: [{
            n: 'observableProperty',
            rq: true,
            en: 'ObservableProperty',
            ti: '.ObservablePropertyType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ConstraintPropertyType',
        ps: [{
            n: 'allowedTimes',
            rq: true,
            en: {
              lp: 'AllowedTimes',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.AllowedTimesType'
          }, {
            n: 'allowedTokens',
            rq: true,
            en: {
              lp: 'AllowedTokens',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.AllowedTokensType'
          }, {
            n: 'allowedValues',
            rq: true,
            en: {
              lp: 'AllowedValues',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.AllowedValuesType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'DescribedObjectPropertyType',
        ps: [{
            n: 'describedObject',
            rq: true,
            mx: false,
            dom: false,
            en: 'DescribedObject',
            ti: '.DescribedObjectType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }, {
            n: 'owns',
            ti: 'Boolean',
            an: {
              lp: 'owns'
            },
            t: 'a'
          }]
      }, {
        ln: 'SimpleProcessPropertyType',
        ps: [{
            n: 'simpleProcess',
            rq: true,
            en: 'SimpleProcess',
            ti: '.SimpleProcessType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }, {
            n: 'owns',
            ti: 'Boolean',
            an: {
              lp: 'owns'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractSettingsType',
        bti: 'SWE_2_0.AbstractSWEType'
      }, {
        ln: 'AbstractSettingsPropertyType',
        ps: [{
            n: 'abstractSettings',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractSettings',
            ti: '.AbstractSettingsType',
            t: 'er'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CharacteristicListType.Characteristic',
        tn: null,
        bti: 'SWE_2_0.AbstractDataComponentPropertyType',
        ps: [{
            n: 'name',
            rq: true,
            ti: 'NCName',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'PhysicalSystemPropertyType',
        ps: [{
            n: 'physicalSystem',
            rq: true,
            en: 'PhysicalSystem',
            ti: '.PhysicalSystemType'
          }, {
            n: 'owns',
            ti: 'Boolean',
            an: {
              lp: 'owns'
            },
            t: 'a'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ArraySettingPropertyType.ArrayValues',
        tn: null,
        ps: [{
            n: 'encoding',
            rq: true,
            ti: '.ArraySettingPropertyType.ArrayValues.Encoding'
          }, {
            n: 'value',
            rq: true,
            ti: 'SWE_2_0.EncodedValuesPropertyType'
          }]
      }, {
        ln: 'DocumentListPropertyType',
        ps: [{
            n: 'documentList',
            rq: true,
            en: 'DocumentList',
            ti: '.DocumentListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'DescribedObjectType.Capabilities',
        tn: null,
        bti: '.CapabilityListPropertyType',
        ps: [{
            n: 'name',
            rq: true,
            ti: 'NCName',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'ModeType',
        bti: '.DescribedObjectType',
        ps: [{
            n: 'configuration',
            rq: true,
            ti: '.SettingsPropertyType'
          }]
      }, {
        ln: 'AbstractProcessType.FeaturesOfInterest',
        tn: null,
        ps: [{
            n: 'featureList',
            rq: true,
            en: 'FeatureList',
            ti: '.FeatureListType'
          }]
      }, {
        ln: 'DataInterfacePropertyType',
        ps: [{
            n: 'dataInterface',
            rq: true,
            en: 'DataInterface',
            ti: '.DataInterfaceType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'DataComponentOrObservablePropertyType',
        ps: [{
            n: 'abstractDataComponent',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractDataComponent',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.AbstractDataComponentType',
            t: 'er'
          }, {
            n: 'observableProperty',
            rq: true,
            en: 'ObservableProperty',
            ti: '.ObservablePropertyType'
          }, {
            n: 'dataInterface',
            rq: true,
            en: 'DataInterface',
            ti: '.DataInterfaceType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractProcessType',
        bti: '.DescribedObjectType',
        ps: [{
            n: 'typeOf',
            ti: 'GML_3_2_1.ReferenceType'
          }, {
            n: 'configuration',
            ti: '.AbstractProcessType.Configuration'
          }, {
            n: 'featuresOfInterest',
            ti: '.AbstractProcessType.FeaturesOfInterest'
          }, {
            n: 'inputs',
            ti: '.AbstractProcessType.Inputs'
          }, {
            n: 'outputs',
            ti: '.AbstractProcessType.Outputs'
          }, {
            n: 'parameters',
            ti: '.AbstractProcessType.Parameters'
          }, {
            n: 'modes',
            mno: 0,
            col: true,
            ti: '.AbstractProcessType.Modes'
          }, {
            n: 'definition',
            an: {
              lp: 'definition'
            },
            t: 'a'
          }]
      }, {
        ln: 'OutputListType.Output',
        tn: null,
        bti: '.DataComponentOrObservablePropertyType',
        ps: [{
            n: 'name',
            rq: true,
            ti: 'NCName',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'ContactListType',
        bti: '.AbstractMetadataListType',
        ps: [{
            n: 'contact',
            rq: true,
            col: true,
            ti: 'ISO19139_GMD_20070417.CIResponsiblePartyPropertyType'
          }]
      }, {
        ln: 'AggregateProcessPropertyType',
        ps: [{
            n: 'aggregateProcess',
            rq: true,
            en: 'AggregateProcess',
            ti: '.AggregateProcessType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }, {
            n: 'owns',
            ti: 'Boolean',
            an: {
              lp: 'owns'
            },
            t: 'a'
          }]
      }, {
        ln: 'TermPropertyType',
        ps: [{
            n: 'term',
            rq: true,
            en: 'Term',
            ti: '.TermType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'LinkPropertyType',
        ps: [{
            n: 'link',
            rq: true,
            en: 'Link',
            ti: '.LinkType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'SettingsPropertyType',
        ps: [{
            n: 'settings',
            rq: true,
            en: 'Settings',
            ti: '.SettingsType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractPhysicalProcessType.LocalReferenceFrame',
        tn: null,
        ps: [{
            n: 'spatialFrame',
            rq: true,
            en: 'SpatialFrame',
            ti: '.SpatialFrameType'
          }]
      }, {
        ln: 'AbstractMetadataListPropertyType',
        ps: [{
            n: 'abstractMetadataList',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractMetadataList',
            ti: '.AbstractMetadataListType',
            t: 'er'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ProcessMethodType.Algorithm',
        tn: null,
        ps: [{
            n: 'abstractAlgorithm',
            rq: true,
            en: 'AbstractAlgorithm',
            ti: '.AbstractAlgorithmType'
          }]
      }, {
        ln: 'ComponentListType.Component',
        tn: null,
        bti: '.AbstractProcessPropertyType',
        ps: [{
            n: 'name',
            rq: true,
            ti: 'NCName',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'ConstraintSettingPropertyType',
        ps: [{
            n: 'allowedTimes',
            rq: true,
            en: {
              lp: 'AllowedTimes',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.AllowedTimesType'
          }, {
            n: 'allowedTokens',
            rq: true,
            en: {
              lp: 'AllowedTokens',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.AllowedTokensType'
          }, {
            n: 'allowedValues',
            rq: true,
            en: {
              lp: 'AllowedValues',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.AllowedValuesType'
          }, {
            n: 'ref',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'ConnectionListType.Connection',
        tn: null,
        ps: [{
            n: 'link',
            rq: true,
            en: 'Link',
            ti: '.LinkType'
          }]
      }, {
        ln: 'CapabilityListPropertyType',
        ps: [{
            n: 'capabilityList',
            rq: true,
            en: 'CapabilityList',
            ti: '.CapabilityListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'TemporalFrameType',
        bti: 'SWE_2_0.AbstractSWEIdentifiableType',
        ps: [{
            n: 'origin',
            rq: true
          }]
      }, {
        ln: 'ComponentListPropertyType',
        ps: [{
            n: 'componentList',
            rq: true,
            en: 'ComponentList',
            ti: '.ComponentListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'TermType',
        bti: 'SWE_2_0.AbstractSWEType',
        ps: [{
            n: 'label',
            rq: true
          }, {
            n: 'codeSpace',
            ti: 'SWE_2_0.Reference'
          }, {
            n: 'value',
            rq: true
          }, {
            n: 'definition',
            an: {
              lp: 'definition'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractPhysicalProcessType.LocalTimeFrame',
        tn: null,
        ps: [{
            n: 'temporalFrame',
            rq: true,
            en: 'TemporalFrame',
            ti: '.TemporalFrameType'
          }]
      }, {
        ln: 'AbstractMetadataListType',
        bti: 'SWE_2_0.AbstractSWEIdentifiableType',
        ps: [{
            n: 'definition',
            an: {
              lp: 'definition'
            },
            t: 'a'
          }]
      }, {
        ln: 'FeatureListPropertyType',
        ps: [{
            n: 'featureList',
            rq: true,
            en: 'FeatureList',
            ti: '.FeatureListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ProcessMethodType',
        bti: 'SWE_2_0.AbstractSWEIdentifiableType',
        ps: [{
            n: 'algorithm',
            mno: 0,
            col: true,
            ti: '.ProcessMethodType.Algorithm'
          }]
      }, {
        ln: 'InputListPropertyType',
        ps: [{
            n: 'inputList',
            rq: true,
            en: 'InputList',
            ti: '.InputListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'LinkType',
        ps: [{
            n: 'source',
            rq: true,
            ti: '.DataComponentRefPropertyType'
          }, {
            n: 'destination',
            rq: true,
            ti: '.DataComponentRefPropertyType'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractProcessType.Modes',
        tn: null,
        ps: [{
            n: 'abstractModes',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractModes',
            ti: '.AbstractModesType',
            t: 'er'
          }]
      }, {
        ln: 'DescribedObjectType.Characteristics',
        tn: null,
        bti: '.CharacteristicListPropertyType',
        ps: [{
            n: 'name',
            rq: true,
            ti: 'NCName',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'DescribedObjectType.ValidTime',
        tn: null,
        ps: [{
            n: 'timePeriod',
            rq: true,
            en: {
              lp: 'TimePeriod',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            ti: 'GML_3_2_1.TimePeriodType'
          }, {
            n: 'timeInstant',
            rq: true,
            en: {
              lp: 'TimeInstant',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            ti: 'GML_3_2_1.TimeInstantType'
          }]
      }, {
        ln: 'CharacteristicListPropertyType',
        ps: [{
            n: 'characteristicList',
            rq: true,
            en: 'CharacteristicList',
            ti: '.CharacteristicListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CharacteristicListType',
        bti: '.AbstractMetadataListType',
        ps: [{
            n: 'characteristic',
            rq: true,
            col: true,
            ti: '.CharacteristicListType.Characteristic'
          }]
      }, {
        ln: 'AbstractPhysicalProcessType',
        bti: '.AbstractProcessType',
        ps: [{
            n: 'attachedTo',
            ti: 'GML_3_2_1.ReferenceType'
          }, {
            n: 'localReferenceFrame',
            mno: 0,
            col: true,
            ti: '.AbstractPhysicalProcessType.LocalReferenceFrame'
          }, {
            n: 'localTimeFrame',
            mno: 0,
            col: true,
            ti: '.AbstractPhysicalProcessType.LocalTimeFrame'
          }, {
            n: 'position',
            mno: 0,
            col: true,
            ti: '.PositionUnionPropertyType'
          }, {
            n: 'timePosition',
            mno: 0,
            col: true,
            ti: 'SWE_2_0.TimePropertyType'
          }]
      }, {
        ln: 'DataInterfaceType',
        bti: 'SWE_2_0.AbstractSWEIdentifiableType',
        ps: [{
            n: 'data',
            rq: true,
            ti: 'SWE_2_0.DataStreamPropertyType'
          }, {
            n: 'interfaceParameters',
            ti: 'SWE_2_0.DataRecordPropertyType'
          }]
      }, {
        ln: 'StatusSettingPropertyType',
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'ref',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'ModeSettingPropertyType',
        ps: [{
            n: 'value',
            ti: 'NCName',
            t: 'v'
          }, {
            n: 'ref',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'IdentifierListType.Identifier',
        tn: null,
        ps: [{
            n: 'term',
            rq: true,
            en: 'Term',
            ti: '.TermType'
          }]
      }, {
        ln: 'ArraySettingPropertyType',
        ps: [{
            n: 'arrayValues',
            rq: true,
            en: 'ArrayValues',
            ti: '.ArraySettingPropertyType.ArrayValues'
          }, {
            n: 'ref',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractModesType',
        bti: 'SWE_2_0.AbstractSWEType'
      }, {
        ln: 'EventType',
        bti: 'SWE_2_0.AbstractSWEIdentifiableType',
        ps: [{
            n: 'keywords',
            mno: 0,
            col: true,
            ti: 'ISO19139_GMD_20070417.MDKeywordsPropertyType'
          }, {
            n: 'identification',
            mno: 0,
            col: true,
            ti: '.IdentifierListPropertyType'
          }, {
            n: 'classification',
            mno: 0,
            col: true,
            ti: '.ClassifierListPropertyType'
          }, {
            n: 'contacts',
            mno: 0,
            col: true,
            ti: '.ContactListPropertyType'
          }, {
            n: 'documentation',
            mno: 0,
            col: true,
            ti: '.DocumentListPropertyType'
          }, {
            n: 'time',
            rq: true,
            ti: '.EventType.Time'
          }, {
            n: 'property',
            mno: 0,
            col: true,
            ti: 'SWE_2_0.AbstractDataComponentPropertyType'
          }, {
            n: 'configuration',
            ti: '.EventType.Configuration'
          }, {
            n: 'definition',
            an: {
              lp: 'definition'
            },
            t: 'a'
          }]
      }, {
        ln: 'FeatureListType',
        bti: '.AbstractMetadataListType',
        ps: [{
            n: 'feature',
            rq: true,
            col: true,
            ti: 'GML_3_2_1.FeaturePropertyType'
          }]
      }, {
        ln: 'CapabilityListType',
        bti: '.AbstractMetadataListType',
        ps: [{
            n: 'capability',
            rq: true,
            col: true,
            ti: '.CapabilityListType.Capability'
          }]
      }, {
        ln: 'OutputListType',
        bti: 'SWE_2_0.AbstractSWEType',
        ps: [{
            n: 'output',
            rq: true,
            col: true,
            ti: '.OutputListType.Output'
          }]
      }, {
        ln: 'DocumentListType',
        bti: '.AbstractMetadataListType',
        ps: [{
            n: 'document',
            rq: true,
            col: true,
            ti: 'ISO19139_GMD_20070417.CIOnlineResourcePropertyType'
          }]
      }, {
        ln: 'EventPropertyType',
        ps: [{
            n: 'event',
            rq: true,
            en: 'Event',
            ti: '.EventType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'SpatialFrameType',
        bti: 'SWE_2_0.AbstractSWEIdentifiableType',
        ps: [{
            n: 'origin',
            rq: true
          }, {
            n: 'axis',
            rq: true,
            col: true,
            ti: '.SpatialFrameType.Axis'
          }]
      }, {
        ln: 'PositionUnionPropertyType',
        ps: [{
            n: 'text',
            rq: true,
            en: {
              lp: 'Text',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.TextType'
          }, {
            n: 'point',
            rq: true,
            en: {
              lp: 'Point',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            ti: 'GML_3_2_1.PointType'
          }, {
            n: 'vector',
            rq: true,
            en: {
              lp: 'Vector',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.VectorType'
          }, {
            n: 'dataRecord',
            rq: true,
            en: {
              lp: 'DataRecord',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.DataRecordType'
          }, {
            n: 'dataArray',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'DataArray',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.DataArrayType',
            t: 'er'
          }, {
            n: 'abstractProcess',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractProcess',
            ti: '.AbstractProcessType',
            t: 'er'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'SpatialFrameType.Axis',
        tn: null,
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'name',
            rq: true,
            ti: 'NCName',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'ProcessMethodPropertyType',
        ps: [{
            n: 'processMethod',
            rq: true,
            en: 'ProcessMethod',
            ti: '.ProcessMethodType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractProcessType.Configuration',
        tn: null,
        ps: [{
            n: 'abstractSettings',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractSettings',
            ti: '.AbstractSettingsType',
            t: 'er'
          }]
      }, {
        ln: 'ArraySettingPropertyType.ArrayValues.Encoding',
        tn: null,
        ps: [{
            n: 'abstractEncoding',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractEncoding',
              ns: 'http:\/\/www.opengis.net\/swe\/2.0'
            },
            ti: 'SWE_2_0.AbstractEncodingType',
            t: 'er'
          }]
      }, {
        ln: 'AbstractAlgorithmType',
        ps: [{
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractAlgorithmPropertyType',
        ps: [{
            n: 'abstractAlgorithm',
            rq: true,
            en: 'AbstractAlgorithm',
            ti: '.AbstractAlgorithmType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ConnectionListType',
        bti: 'SWE_2_0.AbstractSWEType',
        ps: [{
            n: 'connection',
            rq: true,
            col: true,
            ti: '.ConnectionListType.Connection'
          }]
      }, {
        ln: 'ComponentListType',
        bti: 'SWE_2_0.AbstractSWEType',
        ps: [{
            n: 'component',
            rq: true,
            col: true,
            ti: '.ComponentListType.Component'
          }]
      }, {
        ln: 'IdentifierListType',
        bti: '.AbstractMetadataListType',
        ps: [{
            n: 'smlIdentifier',
            rq: true,
            col: true,
            en: 'identifier',
            ti: '.IdentifierListType.Identifier'
          }]
      }, {
        ln: 'InputListType',
        bti: 'SWE_2_0.AbstractSWEType',
        ps: [{
            n: 'input',
            rq: true,
            col: true,
            ti: '.InputListType.Input'
          }]
      }, {
        ln: 'InputListType.Input',
        tn: null,
        bti: '.DataComponentOrObservablePropertyType',
        ps: [{
            n: 'name',
            rq: true,
            ti: 'NCName',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'TimeInstantOrPeriodPropertyType',
        ps: [{
            n: 'timePeriod',
            rq: true,
            en: {
              lp: 'TimePeriod',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            ti: 'GML_3_2_1.TimePeriodType'
          }, {
            n: 'timeInstant',
            rq: true,
            en: {
              lp: 'TimeInstant',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            ti: 'GML_3_2_1.TimeInstantType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'SpatialFramePropertyType',
        ps: [{
            n: 'spatialFrame',
            rq: true,
            en: 'SpatialFrame',
            ti: '.SpatialFrameType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'KeywordListPropertyType',
        ps: [{
            n: 'keywordList',
            rq: true,
            en: 'KeywordList',
            ti: '.KeywordListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'IdentifierListPropertyType',
        ps: [{
            n: 'identifierList',
            rq: true,
            en: 'IdentifierList',
            ti: '.IdentifierListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'KeywordListType',
        bti: '.AbstractMetadataListType',
        ps: [{
            n: 'codeSpace',
            ti: 'SWE_2_0.Reference'
          }, {
            n: 'keyword',
            rq: true,
            col: true
          }]
      }, {
        ln: 'ParameterListType',
        bti: 'SWE_2_0.AbstractSWEType',
        ps: [{
            n: 'parameter',
            rq: true,
            col: true,
            ti: '.ParameterListType.Parameter'
          }]
      }, {
        ln: 'ConnectionListPropertyType',
        ps: [{
            n: 'connectionList',
            rq: true,
            en: 'ConnectionList',
            ti: '.ConnectionListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ClassifierListType.Classifier',
        tn: null,
        ps: [{
            n: 'term',
            rq: true,
            en: 'Term',
            ti: '.TermType'
          }]
      }, {
        ln: 'ObservablePropertyType',
        bti: 'SWE_2_0.AbstractSWEIdentifiableType',
        ps: [{
            n: 'definition',
            rq: true,
            an: {
              lp: 'definition'
            },
            t: 'a'
          }]
      }, {
        ln: 'EventType.Time',
        tn: null,
        ps: [{
            n: 'timePeriod',
            rq: true,
            en: {
              lp: 'TimePeriod',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            ti: 'GML_3_2_1.TimePeriodType'
          }, {
            n: 'timeInstant',
            rq: true,
            en: {
              lp: 'TimeInstant',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            ti: 'GML_3_2_1.TimeInstantType'
          }]
      }, {
        ln: 'ParameterListType.Parameter',
        tn: null,
        bti: '.DataComponentOrObservablePropertyType',
        ps: [{
            n: 'name',
            rq: true,
            ti: 'NCName',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'AggregateProcessType',
        bti: '.AbstractProcessType',
        ps: [{
            n: 'components',
            ti: '.ComponentListPropertyType'
          }, {
            n: 'connections',
            ti: '.ConnectionListPropertyType'
          }]
      }, {
        ln: 'DataComponentRefPropertyType',
        ps: [{
            n: 'ref',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'ContactListPropertyType',
        ps: [{
            n: 'contactList',
            rq: true,
            en: 'ContactList',
            ti: '.ContactListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'OutputListPropertyType',
        ps: [{
            n: 'outputList',
            rq: true,
            en: 'OutputList',
            ti: '.OutputListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractProcessType.Inputs',
        tn: null,
        ps: [{
            n: 'inputList',
            rq: true,
            en: 'InputList',
            ti: '.InputListType'
          }]
      }, {
        ln: 'ParameterListPropertyType',
        ps: [{
            n: 'parameterList',
            rq: true,
            en: 'ParameterList',
            ti: '.ParameterListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ModeChoiceType',
        bti: '.AbstractModesType',
        ps: [{
            n: 'mode',
            rq: true,
            col: true,
            ti: '.ModePropertyType'
          }]
      }, {
        ln: 'EventListPropertyType',
        ps: [{
            n: 'eventList',
            rq: true,
            en: 'EventList',
            ti: '.EventListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CapabilityListType.Capability',
        tn: null,
        bti: 'SWE_2_0.AbstractDataComponentPropertyType',
        ps: [{
            n: 'name',
            rq: true,
            ti: 'NCName',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'ModeChoicePropertyType',
        ps: [{
            n: 'modeChoice',
            rq: true,
            en: 'ModeChoice',
            ti: '.ModeChoiceType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ClassifierListType',
        bti: '.AbstractMetadataListType',
        ps: [{
            n: 'classifier',
            rq: true,
            col: true,
            ti: '.ClassifierListType.Classifier'
          }]
      }, {
        ln: 'SimpleProcessType',
        bti: '.AbstractProcessType',
        ps: [{
            n: 'method',
            ti: '.ProcessMethodPropertyType'
          }]
      }, {
        ln: 'PhysicalSystemType',
        bti: '.AbstractPhysicalProcessType',
        ps: [{
            n: 'components',
            ti: '.ComponentListPropertyType'
          }, {
            n: 'connections',
            ti: '.ConnectionListPropertyType'
          }]
      }, {
        ln: 'ClassifierListPropertyType',
        ps: [{
            n: 'classifierList',
            rq: true,
            en: 'ClassifierList',
            ti: '.ClassifierListType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractProcessPropertyType',
        ps: [{
            n: 'abstractProcess',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractProcess',
            ti: '.AbstractProcessType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }, {
            n: 'owns',
            ti: 'Boolean',
            an: {
              lp: 'owns'
            },
            t: 'a'
          }]
      }, {
        ln: 'EventType.Configuration',
        tn: null,
        ps: [{
            n: 'abstractSettings',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractSettings',
            ti: '.AbstractSettingsType',
            t: 'er'
          }]
      }, {
        ln: 'PhysicalComponentType',
        bti: '.AbstractPhysicalProcessType',
        ps: [{
            n: 'method',
            ti: '.ProcessMethodPropertyType'
          }]
      }, {
        ln: 'SettingsType',
        bti: '.AbstractSettingsType',
        ps: [{
            n: 'setValue',
            mno: 0,
            col: true,
            ti: '.ValueSettingPropertyType'
          }, {
            n: 'setArrayValues',
            mno: 0,
            col: true,
            ti: '.ArraySettingPropertyType'
          }, {
            n: 'setConstraint',
            mno: 0,
            col: true,
            ti: '.ConstraintSettingPropertyType'
          }, {
            n: 'setMode',
            mno: 0,
            col: true,
            ti: '.ModeSettingPropertyType'
          }, {
            n: 'setStatus',
            mno: 0,
            col: true,
            ti: '.StatusSettingPropertyType'
          }]
      }, {
        ln: 'ValueSettingPropertyType',
        ps: [{
            n: 'value',
            ti: 'Token',
            t: 'v'
          }, {
            n: 'ref',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'ModePropertyType',
        ps: [{
            n: 'mode',
            rq: true,
            en: 'Mode',
            ti: '.ModeType'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractModesPropertyType',
        ps: [{
            n: 'abstractModes',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractModes',
            ti: '.AbstractModesType',
            t: 'er'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractPhysicalProcessPropertyType',
        ps: [{
            n: 'abstractPhysicalProcess',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractPhysicalProcess',
            ti: '.AbstractPhysicalProcessType',
            t: 'er'
          }, {
            n: 'owns',
            ti: 'Boolean',
            an: {
              lp: 'owns'
            },
            t: 'a'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'DescribedObjectType',
        bti: 'GML_3_2_1.AbstractFeatureType',
        ps: [{
            n: 'extension',
            mno: 0,
            col: true,
            ti: 'AnyType'
          }, {
            n: 'keywords',
            mno: 0,
            col: true,
            ti: '.KeywordListPropertyType'
          }, {
            n: 'identification',
            mno: 0,
            col: true,
            ti: '.IdentifierListPropertyType'
          }, {
            n: 'classification',
            mno: 0,
            col: true,
            ti: '.ClassifierListPropertyType'
          }, {
            n: 'validTime',
            mno: 0,
            col: true,
            ti: '.DescribedObjectType.ValidTime'
          }, {
            n: 'securityConstraints',
            mno: 0,
            col: true,
            ti: 'AnyType'
          }, {
            n: 'legalConstraints',
            mno: 0,
            col: true,
            ti: 'ISO19139_GMD_20070417.MDLegalConstraintsPropertyType'
          }, {
            n: 'characteristics',
            mno: 0,
            col: true,
            ti: '.DescribedObjectType.Characteristics'
          }, {
            n: 'capabilities',
            mno: 0,
            col: true,
            ti: '.DescribedObjectType.Capabilities'
          }, {
            n: 'contacts',
            mno: 0,
            col: true,
            ti: '.ContactListPropertyType'
          }, {
            n: 'documentation',
            mno: 0,
            col: true,
            ti: '.DocumentListPropertyType'
          }, {
            n: 'history',
            mno: 0,
            col: true,
            ti: '.EventListPropertyType'
          }, {
            n: 'lang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }]
      }, {
        ln: 'PhysicalComponentPropertyType',
        ps: [{
            n: 'physicalComponent',
            rq: true,
            en: 'PhysicalComponent',
            ti: '.PhysicalComponentType'
          }, {
            n: 'owns',
            ti: 'Boolean',
            an: {
              lp: 'owns'
            },
            t: 'a'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml\/3.2'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractProcessType.Outputs',
        tn: null,
        ps: [{
            n: 'outputList',
            rq: true,
            en: 'OutputList',
            ti: '.OutputListType'
          }]
      }, {
        ln: 'EventListType',
        bti: '.AbstractMetadataListType',
        ps: [{
            n: 'event',
            rq: true,
            col: true,
            ti: '.EventPropertyType'
          }]
      }, {
        ln: 'AbstractProcessType.Parameters',
        tn: null,
        ps: [{
            n: 'parameterList',
            rq: true,
            en: 'ParameterList',
            ti: '.ParameterListType'
          }]
      }, {
        t: 'enum',
        ln: 'StatusType',
        vs: ['enabled', 'disabled']
      }],
    eis: [{
        en: 'SpatialFrame',
        ti: '.SpatialFrameType',
        sh: {
          lp: 'AbstractSWEIdentifiable',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'AbstractPhysicalProcess',
        ti: '.AbstractPhysicalProcessType',
        sh: 'AbstractProcess'
      }, {
        en: 'PhysicalSystem',
        ti: '.PhysicalSystemType',
        sh: 'AbstractPhysicalProcess'
      }, {
        en: 'CapabilityList',
        ti: '.CapabilityListType',
        sh: 'AbstractMetadataList'
      }, {
        en: 'ModeChoice',
        ti: '.ModeChoiceType',
        sh: 'AbstractModes'
      }, {
        en: 'ProcessMethod',
        ti: '.ProcessMethodType',
        sh: {
          lp: 'AbstractSWEIdentifiable',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'DataInterface',
        ti: '.DataInterfaceType',
        sh: {
          lp: 'AbstractSWEIdentifiable',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'OutputList',
        ti: '.OutputListType',
        sh: {
          lp: 'AbstractSWE',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'ConnectionList',
        ti: '.ConnectionListType',
        sh: {
          lp: 'AbstractSWE',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'IdentifierList',
        ti: '.IdentifierListType',
        sh: 'AbstractMetadataList'
      }, {
        en: 'Settings',
        ti: '.SettingsType',
        sh: 'AbstractSettings'
      }, {
        en: 'AbstractProcess',
        ti: '.AbstractProcessType',
        sh: 'DescribedObject'
      }, {
        en: 'PhysicalComponent',
        ti: '.PhysicalComponentType',
        sh: 'AbstractPhysicalProcess'
      }, {
        en: 'CharacteristicList',
        ti: '.CharacteristicListType',
        sh: 'AbstractMetadataList'
      }, {
        en: 'AggregateProcess',
        ti: '.AggregateProcessType',
        sh: 'AbstractProcess'
      }, {
        en: 'AbstractSettings',
        ti: '.AbstractSettingsType',
        sh: {
          lp: 'AbstractSWE',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'Link',
        ti: '.LinkType',
        sh: {
          lp: 'AbstractObject',
          ns: 'http:\/\/www.opengis.net\/gml\/3.2'
        }
      }, {
        en: 'AbstractModes',
        ti: '.AbstractModesType',
        sh: {
          lp: 'AbstractSWE',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'AbstractAlgorithm',
        ti: '.AbstractAlgorithmType',
        sh: {
          lp: 'AbstractObject',
          ns: 'http:\/\/www.opengis.net\/gml\/3.2'
        }
      }, {
        en: 'ClassifierList',
        ti: '.ClassifierListType',
        sh: 'AbstractMetadataList'
      }, {
        en: 'Event',
        ti: '.EventType',
        sh: {
          lp: 'AbstractSWEIdentifiable',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'ParameterList',
        ti: '.ParameterListType',
        sh: {
          lp: 'AbstractSWE',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'ObservableProperty',
        ti: '.ObservablePropertyType',
        sh: {
          lp: 'AbstractSWEIdentifiable',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'SimpleProcess',
        ti: '.SimpleProcessType',
        sh: 'AbstractProcess'
      }, {
        en: 'DocumentList',
        ti: '.DocumentListType',
        sh: 'AbstractMetadataList'
      }, {
        en: 'TemporalFrame',
        ti: '.TemporalFrameType',
        sh: {
          lp: 'AbstractSWEIdentifiable',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'FeatureList',
        ti: '.FeatureListType',
        sh: 'AbstractMetadataList'
      }, {
        en: 'KeywordList',
        ti: '.KeywordListType',
        sh: 'AbstractMetadataList'
      }, {
        en: 'AbstractMetadataList',
        ti: '.AbstractMetadataListType',
        sh: {
          lp: 'AbstractSWEIdentifiable',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'ContactList',
        ti: '.ContactListType',
        sh: 'AbstractMetadataList'
      }, {
        en: 'DescribedObject',
        ti: '.DescribedObjectType',
        sh: {
          lp: 'AbstractFeature',
          ns: 'http:\/\/www.opengis.net\/gml\/3.2'
        }
      }, {
        en: 'Term',
        ti: '.TermType',
        sh: {
          lp: 'AbstractSWE',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'InputList',
        ti: '.InputListType',
        sh: {
          lp: 'AbstractSWE',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'ComponentList',
        ti: '.ComponentListType',
        sh: {
          lp: 'AbstractSWE',
          ns: 'http:\/\/www.opengis.net\/swe\/2.0'
        }
      }, {
        en: 'Mode',
        ti: '.ModeType',
        sh: 'DescribedObject'
      }, {
        en: 'EventList',
        ti: '.EventListType',
        sh: 'AbstractMetadataList'
      }]
  };
  return {
    SensorML_2_0: SensorML_2_0
  };
};
if (typeof define === 'function' && define.amd) {
  define([], SensorML_2_0_Module_Factory);
}
else {
  var SensorML_2_0_Module = SensorML_2_0_Module_Factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports.SensorML_2_0 = SensorML_2_0_Module.SensorML_2_0;
  }
  else {
    var SensorML_2_0 = SensorML_2_0_Module.SensorML_2_0;
  }
}